<template>
  <a-drawer
    :maskClosable="false"
    width="35%"
    :label-col="4"
    :wrapper-col="14"
    :visible="open"
    @close="onClose"
    :destroyOnClose="true"
  >
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :model="form" :rules="rules">
      <a-form-model-item label="分配负责点位">
        <a-tree
          v-model="menuCheckedKeys"
          checkable
          readonly
          v-if="open"
          :expanded-keys="menuExpandedKeys"
          :auto-expand-parent="autoExpandParent"
          :tree-data="treeData"
          @check="onCheck"
          @expand="onExpandMenu"
          :replaceFields="defaultProps"
        />
      </a-form-model-item>
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm"> 保存 </a-button>
          <a-button type="dashed" @click="cancel"> 取消 </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import { getObj2, AddAll, putObj, regionListAll } from '@/api/pressure/region'
import areadata from '@/utils/areadata.js'
import Vue from 'vue'

export default {
  name: 'CreateForm',
  data() {
    return {
      menuExpandedKeys: [],
      menuCheckedKeys: [],
      halfCheckedKeys: [],
      autoExpandParent: false,
      submitLoading: false,
      defaultProps: {
        children: 'children',
        title: 'label',
        key: 'value',
      },
      treeData: [],
      form: {
        id: undefined,
        addParams: [],
        menuCheckStrictly: true,
      },
      formTitle: '',
      tenantId: '',
      open: false,
      listDate: [],
      rules: {
        addParams: [{ required: true, message: '请选择点位', trigger: 'change' }],
      },
    }
  },
  created() {
    this.initializeTreeData(areadata)
  },
  methods: {
    initializeTreeData(data, parent = null) {
      return data.map((node) => {
        const newNode = {
          ...node,
          parent,
          disabled: false,
        }
        if (newNode.children) {
          newNode.children = this.initializeTreeData(newNode.children, newNode)
        }
        return newNode
      })
    },
    onClose() {
      this.open = false
      this.$emit('close')
    },
    onExpandMenu(expandedKeys) {
      this.menuExpandedKeys = expandedKeys
      this.autoExpandParent = false
    },
    getNodePath(node) {
      const path = []
      let current = node
      while (current) {
        path.unshift(current)
        current = current.parent
      }
      return path
    },
    getAddress() {
      const arr = []
      this.menuCheckedKeys.forEach((key) => {
        const areaNode = this.findNodeByKey(this.treeData, key)
        if (areaNode) {
          const path = this.getNodePath(areaNode)
          if (path.length >= 3) {
            arr.push({
              province: path[0].label,
              city: path[1].label,
              area: path[2].label,
              tenantId: this.tenantId,
            })
          }
        }
      })
      return arr
    },
    findNodeByKey(nodes, key) {
      for (const node of nodes) {
        if (node.value === key) return node
        if (node.children) {
          const found = this.findNodeByKey(node.children, key)
          if (found) return found
        }
      }
      return null
    },
    findAreaNode(provinceName, cityName, areaName) {
      for (const province of this.treeData) {
        if (province.label === provinceName) {
          for (const city of province.children || []) {
            if (city.label === cityName) {
              for (const area of city.children || []) {
                if (area.label === areaName) {
                  return area
                }
              }
            }
          }
        }
      }
      return null
    },
    disableNodeAndParents(node) {
      if (!node) return

      Vue.set(node, 'disabled', true)

      if (node.parent) {
        const parent = node.parent
        const allChildrenDisabled = parent.children.every((child) => child.disabled)
        if (allChildrenDisabled) {
          Vue.set(parent, 'disabled', true)

          if (parent.parent) {
            const grandParent = parent.parent
            const allGrandChildrenDisabled = grandParent.children.every((child) => child.disabled)
            if (allGrandChildrenDisabled) {
              Vue.set(grandParent, 'disabled', true)
            }
          }
        }
      }
    },
    onCheck(checkedKeys) {
      this.menuCheckedKeys = checkedKeys
    },
    resetTreeData() {
      this.treeData = this.initializeTreeData(areadata)
    },
    cancel() {
      this.open = false
      this.reset()
    },
    reset() {
      this.form = {
        id: undefined,
        addParams: [],
        menuCheckStrictly: true,
      }
      this.resetTreeData()
      this.menuCheckedKeys = []
    },
    handleAdd(e) {
      this.tenantId = e
      this.reset()
      this.formTitle = '添加区域'
      this.open = true
      this.getYiAdd(e)
    },
    getYiAdd(e) {
      regionListAll({ tenantId: e, pageNum: 1, pageSize: 999 }).then((res) => {
        this.listDate = res.data.records
        this.resetTreeData()

        this.listDate.forEach((item) => {
          const areaNode = this.findAreaNode(item.province, item.city, item.area)
          if (areaNode) {
            this.disableNodeAndParents(areaNode)
          }
        })
      })
    },
    handleUpdate(row) {
      this.reset()
      getObj2(row).then((response) => {
        this.form = response.data
        const item = response.data
        this.formTitle = '修改区域'
        this.open = true

        const areaNode = this.findAreaNode(item.province, item.city, item.area)
        if (areaNode) {
          this.disableNodeAndParents(areaNode)
        }
      })
    },
    submitForm() {
      const points = this.getAddress()
      if (points.length === 0) {
        this.$message.error('请先选择点位')
        return
      }
      this.form.addParams = points
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.submitLoading = true
          const action = this.form.id ? putObj(this.form) : AddAll(this.form.addParams)
          action
            .then(() => {
              this.$message.success(this.form.id ? '修改成功' : '新增成功')
              this.open = false
              this.$emit('ok')
            })
            .finally(() => {
              this.submitLoading = false
            })
        }
      })
    },
  },
}
</script>
